import { Tag } from '@chakra-ui/react';

const VTag = ({
  children,
  variant = 'outline',
  size = 'sm',
  closable = false,
  onClose,
  ...props
}: Omit<Tag.RootProps, 'children' | 'colorPalette'> & {
  children: string;
  closable?: boolean;
  onClose?: () => void;
}) => (
  <Tag.Root variant={variant} size={size} {...props}>
    <Tag.Label title={children}>{children}</Tag.Label>
    {closable && (
      <Tag.EndElement>
        <Tag.CloseTrigger type="button" aria-label={`Remove ${children}`} onClick={onClose} />
      </Tag.EndElement>
    )}
  </Tag.Root>
);

export default VTag;
